import PropTypes from 'prop-types';
import React from 'react';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { cloneDeep, intersection, sortBy } from 'lodash';
import queryString from 'query-string';
import * as moment from 'moment';

import ACNavigation from '../ac-react-components/Navigation';

import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import {
    getFilterBarItems,
    getProductCategories,
    getSubscriptionStatus,
    getSubscriptionTier,
    getBookingItemActivityStatuses,
    getBookingItemPaymentStatuses,
} from '../common/global';
import { getOptions, getOptionsByFilters } from '../common/actions/filters';

import styles from './MainPage.module.scss';

const propTypes = {
    authProperties: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired,
    navigationProperties: PropTypes.object.isRequired,
};

const defaultProps = {};

class MainPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuItemKey: 'planner',

            // internal states of filters
            countries: [],
            states: [],
            cities: [],
            users: [],

            resetFilters: false,
            filterByOptions: '',
            loadCountries: true,
            loadStates: true,

            filter: {
                bookingDate: {
                    from: moment(new Date()).format('YYYY-MM-DD'),
                },
            },

            unsavedData: false,
            permissionToLeave: true,
            openDialog: false,
            selection: {},
        };

        this.navigateTo = this.navigateTo.bind(this);
        this.getMainComponent = this.getMainComponent.bind(this);
        this.renderScreen = this.renderScreen.bind(this);
        this.getFilterBar = this.getFilterBar.bind(this);

        this.onChangeCountry = this.onChangeCountry.bind(this);
        this.onChangeState = this.onChangeState.bind(this);

        this.onFilterCountries = this.onFilterCountries.bind(this);
        this.onFilterStates = this.onFilterStates.bind(this);
        this.onFilterCities = this.onFilterCities.bind(this);
        this.onFilterBookings = this.onFilterBookings.bind(this);
        this.onFilterOwners = this.onFilterOwners.bind(this);
        this.onFilterDays = this.onFilterDays.bind(this);
        this.onFilterDietaries = this.onFilterDietaries.bind(this);
        this.onFilterBookingStatuses = this.onFilterBookingStatuses.bind(this);
        this.onFilterConfirmationSent = this.onFilterConfirmationSent.bind(this);
        this.onFilterCodeSent = this.onFilterCodeSent.bind(this);
        this.onFilterRouteSet = this.onFilterRouteSet.bind(this);
        this.onFilterAuthStatus = this.onFilterAuthStatus.bind(this);
        this.onFilterDate = this.onFilterDate.bind(this);
        this.onFilterProductCategories = this.onFilterProductCategories.bind(this);
        this.onFilterSubscriptionStatus = this.onFilterSubscriptionStatus.bind(this);
        this.onClearFilter = this.onClearFilter.bind(this);
        this.onFilterIsPersonalisationCompleted=this.onFilterIsPersonalisationCompleted.bind(this);
        this.onFilterIsSurveyCompleted=this.onFilterIsSurveyCompleted.bind(this);

        this.onClickDialogYes = this.onClickDialogYes.bind(this);
        this.onClickDialogNo = this.onClickDialogNo.bind(this);

        this.setUnsavedDataFlag = this.setUnsavedDataFlag.bind(this);

        this.onSelectACDrawerMenuItem = this.onSelectACDrawerMenuItem.bind(this);
    }

    componentWillReceiveProps(props) {
        if (props.users && props.users !== this.props.users) {
            this.setState({
                users: props.users,
            });
        }

        if (props.options) {
            let cities = [];
            if (props.options.countries && this.state.loadCountries === true) {
                this.setState({
                    loadCountries: false,
                });
                let countries = [];
                countries = sortBy(props.options.countries);
                this.setState({
                    countries,
                });
            }
            if (props.options.states && this.state.loadStates === true) {
                this.setState({
                    loadStates: false,
                });
                let states = [];
                states = sortBy(props.options.states);
                this.setState({
                    states,
                });
            }
            if (props.options.cities) cities = sortBy(props.options.cities);

            this.setState({
                cities,
            });
        }
    }

    componentDidMount() {
        this.navigateTo(this.state.menuItemKey);
    }

    onChangeCountry(selectedCountries) {
        let filterBy = '';
        selectedCountries.forEach((country) => {
            filterBy += '&countries=' + country;
        });

        this.setState({
            resetFilters: false,
            filterByOptions: filterBy,
            loadStates: true,
        });

        this.props.getOptionsByFiltersFunc(filterBy.slice(1));
    }

    onChangeState(selectedStates) {
        let filterBy = '';

        selectedStates.forEach((s) => {
            filterBy += '&states=' + s;
        });

        this.setState({
            resetFilters: false,
            filterByOptions: filterBy,
        });

        this.props.getOptionsByFiltersFunc(filterBy.slice(1));
    }

    onFilterOwners(owners) {
        let filter = cloneDeep(this.state.filter);
        if (owners === null) {
            filter.owners = [];
        }
        let ownerIds = this.getUserIds(owners);

        filter.owners = ownerIds;

        this.setState({
            resetFilters: false,
            filter,
        });
    }

    onFilterProductCategories(productCategories) {
        let filter = cloneDeep(this.state.filter);

        if (productCategories === null) {
            filter.productCategories = [];
        } else {
            productCategories = intersection(getProductCategories(), productCategories);
        }
        filter.productCategories = productCategories;

        this.setState({
            resetFilters: false,
            filter,
        });
    }

    onFilterSubscriptionStatus(subscriptionStatus) {
        let filter = cloneDeep(this.state.filter);
        let subscriptionTier = [];

        if (subscriptionStatus === null) {
            filter.subscriptionStatus = [];
        } else {
            subscriptionTier = intersection(getSubscriptionTier(), subscriptionStatus);
            subscriptionStatus = intersection(getSubscriptionStatus(), subscriptionStatus);
        }
        filter.subscriptionTier = subscriptionTier;
        filter.subscriptionStatus = subscriptionStatus;

        this.setState({
            resetFilters: false,
            filter,
        });
    }

    onFilterDays(days) {
        let filter = cloneDeep(this.state.filter);
        if (days === null) {
            filter.days = [];
        }

        filter.days = days;

        this.setState({
            resetFilters: false,
            filter,
        });
    }

    onFilterDietaries(dietaries) {
        let filter = cloneDeep(this.state.filter);
        if (dietaries === null) {
            filter.dietaries = [];
        }

        let mappedDietaries = this.getMappedDietaries(dietaries);

        filter.dietaries = mappedDietaries;

        this.setState({
            resetFilters: false,
            filter,
        });
    }

    onFilterBookingStatuses(bookingStatuses) {
        let filter = cloneDeep(this.state.filter);
        if (bookingStatuses === null) {
            filter.bookingStatuses = [];
        }

        filter.bookingStatuses = bookingStatuses;
        this.setState({
            resetFilters: false,
            filter,
        });
    }

    onFilterConfirmationSent(confirmationSent) {
        let filter = cloneDeep(this.state.filter);
        if (confirmationSent === null) {
            filter.confirmationSent = [];
        }

        filter.confirmationSent = this.getMappedSentStatuses(confirmationSent);

        this.setState({
            resetFilters: false,
            filter,
        });
    }

    onFilterCodeSent(codeSent) {
        let filter = cloneDeep(this.state.filter);
        if (codeSent === null) {
            filter.codeSent = [];
        }

        filter.codeSent = this.getMappedSentStatuses(codeSent);

        this.setState({
            resetFilters: false,
            filter,
        });
    }

    onFilterIsPersonalisationCompleted(value) {
        let filter = cloneDeep(this.state.filter);
        
        if (value === null) {
            filter.isPersonalisedCompleted = [];
        }

        filter.isPersonalisedCompleted = this.getMappedSentStatuses(value);
        this.setState({
            resetFilters: false,
            filter,
        });
    }

    onFilterIsSurveyCompleted(value) {
        let filter = cloneDeep(this.state.filter);
        if (value === null) {
            filter.surveyCompleted = [];
        }

        filter.surveyCompleted = this.getMappedSentStatuses(value);

        this.setState({
            resetFilters: false,
            filter,
        });
    }
    
    onFilterRouteSet(routeSet) {
        let filter = cloneDeep(this.state.filter);
        if (routeSet === null) {
            filter.routeSet = [];
        }

        filter.routeSet = this.getMappedSentStatuses(routeSet);

        this.setState({
            resetFilters: false,
            filter,
        });
    }

    onFilterAuthStatus(authStatus) {
        let filter = cloneDeep(this.state.filter);
        if (authStatus === null) {
            filter.authStatus = [];
        }

        filter.authStatus = this.getMappedAuthStatus(authStatus);

        this.setState({
            resetFilters: false,
            filter,
        });
    }

    onFilterCountries(countries) {
        let filter = cloneDeep(this.state.filter);
        if (countries === null) {
            filter.countries = [];
        }
        filter.countries = countries;

        this.setState({
            resetFilters: false,
            filter,
        });
    }

    onFilterStates(states) {
        let filter = cloneDeep(this.state.filter);
        if (states === null) {
            filter.states = [];
        }
        filter.states = states;

        this.setState({
            resetFilters: false,
            filter,
        });
    }

    onFilterCities(cities) {
        let filter = cloneDeep(this.state.filter);
        if (cities === null) {
            filter.cities = [];
        }
        filter.cities = cities;

        this.setState({
            resetFilters: false,
            filter,
        });
    }

    onFilterDate(key, date) {
        let filter = cloneDeep(this.state.filter);
        if (date === null) {
            filter.bookingDate = {};
        }
        let bookingDate = filter.bookingDate;
        if (!bookingDate) {
            bookingDate = {
                from: '',
                to: '',
            };
        }
        if (key === 'from') bookingDate.from = date;
        if (key === 'to') bookingDate.to = date;

        filter.bookingDate = bookingDate;
        this.setState({
            resetFilters: false,
            filter,
        });
    }

    /**
     * Filter by product name
     * @since 2020-01-14
     * @param {*} value product Name text field value
     */
    onFilterByProductName = (value) => {
        let { filter } = this.state;
        filter = { ...filter, productName: value };
        this.setState({ filter, resetFilters: false });
    };

    onFilterByPageNumber = (pageNumber) => {
        let { filter } = this.state;
        filter = { ...filter, pageNumber };
        this.setState({ filter, resetFilters: false });
    };

    /**
     * Sort/filter data by booking note
     */
    onSortByDateFunc = (sortByValue) => {
        let { filter } = this.state;
        const sortByBookingNote = sortByValue === 'noteDate';
        filter = { ...filter, sortByBookingNote };
        this.setState({ filter, resetFilters: false });
    };

    /**
     * Filter by booking stop item status. If the value is true, then show if the status is not one of [Completed, Booked, No Booking Required]
     * @since 2020-01-17
     * @values filtered statuses. If [completed, not complete, waiting to hear, etc].
     */
    onFilterByBookingRouteStopItemActivityStatus = (values) => {
        let filter = cloneDeep(this.state.filter);
        if (values === null) {
            filter.bookingRouteStopItemActivityStatuses = [];
        }

        filter.bookingRouteStopItemActivityStatuses = this.getMappedBookingRouteStopItemActivityStatuses(values);
        this.setState({
            filter,
            resetFilters: false,
        });
    };

    onFilterByProviderBookingStatus = (values) => {
        let filter = cloneDeep(this.state.filter);
        if (values === null) {
            filter.providerBookingStatus = [];
        }

        filter.providerBookingStatus = this.getMappedProviderBookingStatuses(values);
        this.setState({
            filter,
            resetFilters: false,
        });
    };

    onFilterByProviderPaymentStatus = (values) => {
        let filter = cloneDeep(this.state.filter);
        if (values === null) {
            filter.providerPaymentStatus = [];
        }

        filter.providerPaymentStatus = this.getMappedProviderPaymentStatuses(values);
        this.setState({
            filter,
            resetFilters: false,
        });
    };

    onFilterBookings(hqId) {
        let filter = cloneDeep(this.state.filter);
        filter.hqId = hqId;
        this.setState({ resetFilters: false, filter });
    }

    onClearFilter() {
        let filter = cloneDeep(this.state.filter);
        filter = {
            bookingDate: {
                from: moment(new Date()).format('YYYY-MM-DD'),
            },
        };
        this.setState({
            resetFilters: false,
            loadCountries: true,
            loadStates: true,
            filter,
        });
        this.props.getOptionsFunc();
    }

    onSelectACDrawerMenuItem(menuItemKey) {
        this.navigateTo(menuItemKey);
    }

    onClickDialogYes() {
        this.setState(
            {
                openDialog: false,
                permissionToLeave: true,
            },
            // Callback function has been used to make the selection,
            // if the user decides to leave the changes.
            () => {
                this.navigateTo(this.state.selection);
            }
        );
    }

    getUserIds(owners) {
        let userIds = [];
        owners.forEach((o) => {
            let found = this.state.users.find((u) => {
                return u.name === o;
            });

            if (found) userIds.push(found.id);
            if (o === 'Unassigned') userIds.push(-1); //added unique userid (-1) for unassigned owner filter option
        });
        return userIds;
    }

    getParamsFromUrl() {
        const { search } = this.props.location;
        const params = queryString.parse(search);
        return params;
    }

    getMainComponent(authProperties, config, navigationProperties) {
        let mainComponent;
        let { selectedNavigationItem } = navigationProperties;
        const params = this.getParamsFromUrl();

        const { id = '', hqId = '', productId = '' } = params;
        const pageNumber = Number(params.pageNumber) || 0;

        if (selectedNavigationItem) {
            const OrganismComponent = selectedNavigationItem.component;
            mainComponent = (
                <OrganismComponent
                    authProperties={authProperties}
                    config={config}
                    filter={this.state.filter}
                    id={id}
                    hqId={hqId}
                    productId={productId}
                    pageNumber={pageNumber}
                    setUnsavedDataFlagFunc={this.setUnsavedDataFlag}
                    onSelectACDrawerMenuItemFunc={this.onSelectACDrawerMenuItem}
                    onFilterByPageNumberFunc={this.onFilterByPageNumber}
                    onSortByDateFunc={this.onSortByDateFunc}
                />
            );
        }
        return mainComponent;
    }

    onClickDialogNo() {
        this.setState({
            openDialog: false,
        });
    }

    getFilterBar(navigationProperties) {
        let { selectedNavigationItem } = navigationProperties;
        let filterBarComponent;
        const navigationItemText = selectedNavigationItem.text.toLowerCase() || '';
        const filterBarItems = getFilterBarItems();

        if (navigationItemText && filterBarItems[navigationItemText]) {
            const FilterComponent = filterBarItems[navigationItemText].component;
            filterBarComponent = (
                <FilterComponent
                    pageName={navigationItemText}
                    resetFilters={this.state.resetFilters}
                    countries={this.state.countries}
                    states={this.state.states}
                    cities={this.state.cities}
                    users={this.state.users}
                    onChangeCountryFunc={this.onChangeCountry}
                    onChangeStateFunc={this.onChangeState}
                    onFilterCountriesFunc={this.onFilterCountries}
                    onFilterStatesFunc={this.onFilterStates}
                    onFilterCitiesFunc={this.onFilterCities}
                    onFilterBookingsFunc={this.onFilterBookings}
                    onFilterOwnersFunc={this.onFilterOwners}
                    onFilterDaysFunc={this.onFilterDays}
                    onFilterDietariesFunc={this.onFilterDietaries}
                    onFilterBookingStatusesFunc={this.onFilterBookingStatuses}
                    onFilterConfirmationSentFunc={this.onFilterConfirmationSent}
                    onFilterCodeSentFunc={this.onFilterCodeSent}
                    onFilterRouteSetFunc={this.onFilterRouteSet}
                    onFilterIsPersonalisationCompletedFunc={this.onFilterIsPersonalisationCompleted}
                    onFilterIsSurveryCompletedFunc={this.onFilterIsSurveyCompleted}
                    onFilterAuthStatusFunc={this.onFilterAuthStatus}
                    onFilterDateFunc={this.onFilterDate}
                    onFilterByProductNameFunc={this.onFilterByProductName}
                    onFilterByBookingRouteStopItemActivityStatusFunc={this.onFilterByBookingRouteStopItemActivityStatus}
                    onFilterProductCategoriesFunc={this.onFilterProductCategories}
                    onFilterSubscriptionStatusFunc={this.onFilterSubscriptionStatus}
                    onFilterByProviderBookingStatusFunc={this.onFilterByProviderBookingStatus}
                    onFilterByProviderPaymentStatusFunc={this.onFilterByProviderPaymentStatus}
                    onClearFilterFunc={this.onClearFilter}
                    authProperties={this.props.authProperties}
                />
            );
        }
        return filterBarComponent;
    }

    getFilterOptions() {
        this.props.getOptionsFunc();
    }

    getMappedDietaries(dietaries) {
        let mappedDietaries = [];
        dietaries.forEach((d) => {
            switch (d) {
                case 'Vegetarian':
                    mappedDietaries.push('vegetarian');
                    break;
                case 'Gluten Free':
                    mappedDietaries.push('glutenFree');
                    break;
                case 'Vegan':
                    mappedDietaries.push('vegan');
                    break;
                default:
                    break;
            }
        });
        return mappedDietaries;
    }

    getMappedBookingRouteStopItemActivityStatuses(statuses) {
        let mappedStatuses = [];
        for (const status of statuses) {
            switch (status) {
                case 'Completed':
                    mappedStatuses.push('completed');
                    break;
                case 'Not Complete':
                    mappedStatuses.push('not-complete');
                    break;
                case 'Not Requested':
                    mappedStatuses.push('not-requested');
                    break;
                case 'Requested/Complete':
                    mappedStatuses.push('requested-completed');
                    break;
                default:
                    break;
            }
        }
        return mappedStatuses;
    }

    getMappedProviderBookingStatuses(statuses) {
        let mappedStatuses = [];
        const providerBookingStatusObject = getBookingItemActivityStatuses();
        statuses.forEach((status) => {
            const s = providerBookingStatusObject.find((item) => item.name === status);
            if (s) mappedStatuses.push(s.value);
        });
        return mappedStatuses;
    }

    getMappedProviderPaymentStatuses(statuses) {
        let mappedStatuses = [];
        const providerPaymentStatusObject = getBookingItemPaymentStatuses();
        statuses.forEach((status) => {
            const s = providerPaymentStatusObject.find((item) => item.name === status);
            if (s) mappedStatuses.push(s.value);
        });
        return mappedStatuses;
    }

    getMappedSentStatuses(sentStatuses) {
        let mappedSentStatuses = [];
        sentStatuses.forEach((d) => {
            switch (d) {
                case 'Yes':
                    mappedSentStatuses.push('true');
                    break;
                case 'No':
                    mappedSentStatuses.push('false');
                    break;
                case 'Queued':
                    mappedSentStatuses.push('Queued');
                    break;
                default:
                    break;
            }
        });
        return mappedSentStatuses;
    }

    getMappedAuthStatus(authStatus) {
        let mappedAuthStatus = [];
        authStatus.forEach((d) => {
            switch (d) {
                case 'Not set':
                    mappedAuthStatus.push('SELECT');
                    break;
                case 'In progress':
                    mappedAuthStatus.push('IN_PROGRESS');
                    break;
                case 'Available':
                    mappedAuthStatus.push('AVAILABLE');
                    break;
                default:
                    break;
            }
        });
        return mappedAuthStatus;
    }

    setUnsavedDataFlag(value) {
        this.setState({
            unsavedData: value,
            permissionToLeave: !value,
        });
    }

    navigateTo(miKey) {
        if (this.state.permissionToLeave !== true) {
            this.setState({
                selection: miKey,
                openDialog: true,
            });
            return;
        }
        this.setState({
            menuItemKey: miKey,
            resetFilters: true,
            loadCountries: true,
            loadStates: true,
        });
        this.getFilterOptions();
    }

    renderConfirmDialog() {
        return (
            <div>
                <Dialog open={this.state.openDialog} aria-labelledby="draggable-dialog-title">
                    <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                        Confirm
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>The data has not been saved yet. Are you sure to leave?</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.onClickDialogYes} color="primary">
                            Yes
                        </Button>
                        <Button onClick={this.onClickDialogNo} color="primary">
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

    renderScreen(authProperties, config, navigationProperties) {
        return (
            <div className={styles.page}>
                {/* FIXME: This needs to be properly done through the ACNavigation. 
                   The fix has been applied to let user navigate if they open a new window with id. 
        */}
                <Link to="/">
                    <ACNavigation
                        authProperties={authProperties}
                        navigationProperties={navigationProperties}
                        isLabelHidden={true}
                    />
                </Link>
                <div style={{ width: '100%' }}>
                    {/* <SessionTimer authProperties={this.props.authProperties} /> */}
                    <div className={styles.top}>{this.getFilterBar(navigationProperties)}</div>
                    <main className={styles.main}>
                        {this.getMainComponent(authProperties, config, navigationProperties)}
                        {this.renderConfirmDialog()}
                    </main>
                </div>
            </div>
        );
    }

    render() {
        const { authProperties, config, navigationProperties } = this.props;
        if (!authProperties || !config || !navigationProperties) return;

        const { loggedInUser } = authProperties;
        if (!loggedInUser) return <Redirect to="/login" />;

        return this.renderScreen(authProperties, config, navigationProperties);
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getOptionsFunc: () => dispatch(getOptions()),
        getOptionsByFiltersFunc: (filterByOptions) => dispatch(getOptionsByFilters(filterByOptions)),
    };
};

const mapStateToProps = (state) => {
    const stateFilters = state.filters;
    const stateUsers = state.users;

    let newProps = {};

    if (stateFilters) {
        if (stateFilters.error) {
            console.error(stateFilters.error.message);
        }
        if (stateFilters.options) {
            newProps.options = stateFilters.options;
        }
    }

    if (stateUsers) {
        if (stateUsers.error) {
            console.error(stateUsers.error.message);
        }
        if (stateUsers.users) {
            newProps.users = stateUsers.users;
        }
    }

    return newProps;
};

MainPage.propTypes = propTypes;
MainPage.defaultProps = defaultProps;

export class SessionTimer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            timeLeft: 0,
        };
    }

    componentDidMount() {
        this.seessionTimerInterval = setInterval(() => {
            const now = new Date().getTime() / 1000;
            const timeLeft = this.props.authProperties.loggedInUser.expiryTimestamp - now;
            this.setState({ timeLeft });
        }, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.seessionTimerInterval);
    }

    displayTime() {
        return new Date(this.state.timeLeft * 1000).toISOString().substr(11, 5);
    }

    render() {
        if (this.state.timeLeft < 600) {
            return (
                <div
                    style={{
                        backgroundColor: '#f00',
                        fontSize: '0.875rem',
                        lineHeight: '1.43',
                        letterSpacing: '0.01071em',
                        fontWeight: 700,
                        opacity: 0.9,
                        color: '#fff'
                    }}
                >
                    Session Expires In <br />
                    {this.displayTime()}
                </div>
            );
        } else {
            return (
                <div
                    style={{
                        // position: 'fixed',
                        // right: '0px',
                        // backgroundColor: '#eee',
                        fontSize: '0.875rem',
                        lineHeight: '1.43',
                        letterSpacing: '0.01071em',
                        fontWeight: 700,
                        opacity: 0.9,
                        color: '#fff'
                    }}
                >
                    {this.displayTime()}
                </div>
            );
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MainPage);
